// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3BmDb","title":"Header_title__2ePSU","side":"Header_side__1IYXA"};